import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { IconButton, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { closeBtnStyles as styles } from './styles';

const CloseBtn = ({ onClick, className, classes }) => {
    return (
        <IconButton className={classNames(classes.button, className)} onClick={onClick}>
            <CloseIcon />
        </IconButton>
    );
};

CloseBtn.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CloseBtn);
